import Id from "../types/Id";
import SuperJSON from "superjson";
import { random } from "lodash-es";

const MIN_RANDOM_VALUE = 1;
const MAX_RANDOM_VALUE = 999999;

export default class CustomerId extends Id<"customer"> {
  protected static validate(value: string) {
    const customerIdNumber = parseInt(value);
    return isFinite(customerIdNumber) && customerIdNumber > 0;
  }

  static random<T>(this: new (value: string) => T): T {
    return new this(random(MIN_RANDOM_VALUE, MAX_RANDOM_VALUE).toString());
  }
}

SuperJSON.registerClass(CustomerId);
